import React from "react";

import * as S from "./styled";

const SignInRegister = () => {
  const handleClick = () => {
    window.gon.state.analyticsData = { source: "nav_homepage" };
    window.gon.state.triggerScenario("EmailCapture");
  };

  return (
    <S.SignInRegisterButton
      aria-label="Sign In / Register"
      className="jsGoogleOneTap"
      onClick={handleClick}
    >
      Sign In / Register
    </S.SignInRegisterButton>
  );
};

export default SignInRegister;
